import type { DeviceCatalogInfo } from '@/components/Combobox/DeviceCatalogCombobox';
import type { DeviceGenre } from '@/constants/device';

/**
 * SDUIのIDと表示名から、既存DeviceCatalogSelectが扱う現在値を組み立てる。
 * 候補一覧用のコードや画像は不要なため、APIの追加取得は行わない。
 */
export function buildDeviceCatalogSelectValue(value?: string, displayValue?: string, deviceGenre?: DeviceGenre): DeviceCatalogInfo | undefined {
  if (!value || !displayValue) return undefined;
  return {
    id: value,
    name: displayValue,
    catalogCode: '',
    deviceType: deviceGenre ?? ''
  };
}